import { UserIcon, TrashIcon } from "@heroicons/react/24/outline";
import Modal from "../../ui-components/Modal";
import AuthenticationService from "../../services/AuthenticationService";
import Button from "../../ui-components/Button";
import {useState} from "react";

export const SharingInfoModal = ({
  worksite,
  showSharing,
  setShowSharing,
  removeSharing,
  intl
}) => {
  const userData = AuthenticationService.getUserData();
  const [askConfirmation, setAskConfirmation] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  return (
    <Modal onExit={() => setShowSharing(false)}>
      {!askConfirmation ? <div className="flex w-full flex-col h-full">
        <label className="block text-lg font-bold mb-5">
          {intl.formatMessage({ id: "shared_users" })}
        </label>
        {(showSharing || []).map((user, n) => (
          <div key={n} className="grid grid-cols-5 my-4">
            <div
              className={"text-center" }
            >
              {
                (userData.role_type === "admin" ||
                  [userData.id, userData.account_user_id].includes(worksite.id_creator) ||
                  [userData.id, userData.account_user_id].includes(user.id)) && removeSharing
                ? (
                <TrashIcon
                  className="mt-3 h-5 w-5 inline-block cursor-pointer text-red-500"
                  aria-hidden="true"
                  onClick={() => {
                    setAskConfirmation(true);
                    setSelectedUser(user);
                    // removeSharing(user);
                  }}
                />
              ) : (
                <UserIcon
                  className="mt-3 h-5 w-5 inline-block text-black-500"
                  aria-hidden="true"
                />
              )}
            </div>
            <div className="col-span-4">
              <span>
                {user.firstname} {user.lastname}{" "}
              </span>
              <br />
              <span className="italic text-sm">
                {intl.formatMessage({ id: user.account_user?.role?.name || user.role.name })}
              </span>
            </div>
          </div>
        ))}
      </div>: <div className="flex w-full flex-col h-full">
        <label className="block text-lg font-bold mb-5">
          {
            userData.id === selectedUser.id?
              intl.formatMessage({id: "confirm_remove_own_sharing", defaultMessage: "Sei sicuro di voler rimuovere la condivisione? Perderai l'accesso al cantiere."}):
              intl.formatMessage({id: "confirm_remove_sharing", defaultMessage:"Sei sicuro di voler rimuovere la condivisione del cantiere a {name}?"}, {name: `${selectedUser.firstname} ${selectedUser.lastname}`})
          }
        </label>
        <div
          className={"flex flex-row items-center gap-10 justify-center"}
        >
          <Button
            onClick={() => {
              setAskConfirmation(false);
              setSelectedUser(null);
            }}
            styleType={"white"}
          >
            {intl.formatMessage({id: "cancel"})}
          </Button>
          <Button
            onClick={() => {
              removeSharing(selectedUser);
            }}
          >
            {intl.formatMessage({id: "confirm"})}
          </Button>
        </div>
      </div>}
    </Modal>
  );
}
